import {Button, Form, Modal} from "react-bootstrap";

import './EditContactModal.scss';
import {createContact, editContact, formatPhoneNumber} from "../../../Services/ApiService";

function EditContactModal(props) {
    const contact = props.newContact;

    function handleSaveClicked() {
        if (contact.get().id.toString() !== '-1') {
            editContact(contact.get(), () => {
                props.updateContacts(_ => {});
            });
        } else {
            createContact(contact.get(), () => {
                props.updateContacts(_ => {});
            });
        }
        props.handleClose();
    }

    // noinspection JSValidateTypes
    return (
        <Modal show={props.show} onHide={props.handleClose} size={'md'} id={'editContactModal'}>
            <Modal.Body>
                <Form>
                    <Form.Label>Name:
                        <Form.Control id={`name`}
                                      onChange={(e => contact.name.set(e.target.value))}
                                      value={contact.get().name}
                        />
                    </Form.Label>
                    <Form.Label>Phone:
                        <Form.Control id={`phone`}
                                      onChange={(e => contact.phone.set(e.target.value))}
                                      value={formatPhoneNumber(contact.get().phone)}
                        />
                    </Form.Label>
                    <Form.Label>Email:
                        <Form.Control id={`email`}
                                      onChange={(e => contact.email.set(e.target.value))}
                                      value={contact.get().email}
                        />
                    </Form.Label>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleSaveClicked}>Save</Button>
                <Button onClick={props.handleClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default EditContactModal;